import { Link } from 'react-router-dom';

import { FaHome } from 'react-icons/fa';
import { MdOutlineArrowBackIos } from 'react-icons/md';

const Breadcrumb = (props: any) => {
  return (
    <nav className="flex" aria-label="Breadcrumb">
      <ol className="inline-flex items-center space-x-1 md:space-x-2 rtl:space-x-reverse">
        <FaHome className="text-gray-300" />
        {props.breadcrumbs.itemListElement &&
          props.breadcrumbs.itemListElement.map(
            (element: any, index: number) => {
              const isFirst = index === 0;

              return (
                <div key={index} className="flex items-center">
                  {!isFirst ? (
                    <MdOutlineArrowBackIos className="text-gray-300" />
                  ) : null}
                  <Link
                    to={element.item.url}
                    className="ms-1 text-xs lg:text-sm font-medium text-gray-300 hover:text-gray-400 md:ms-2"
                  >
                    {element.item.name}
                  </Link>
                </div>
              );
            }
          )}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
